/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ladybug': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12 5c.74 0 1.47.1 2.15.29l1.63-2.83c.28-.46.89-.64 1.37-.36.48.27.64.9.35 1.36L16 6.07A8.07 8.07 0 0118.93 9H5.07A8.07 8.07 0 018 6.07L6.5 3.46a.978.978 0 01.35-1.36c.48-.28 1.09-.1 1.37.36l1.63 2.83C10.53 5.1 11.26 5 12 5m8 8a8 8 0 01-7.25 7.97V10.5h6.85c.26.79.4 1.63.4 2.5M4 13c0-.87.14-1.71.4-2.5h6.85v10.47A8 8 0 014 13z"/>'
  }
})
